import React from "react";
import { CalendarDaysIcon, ClipboardListIcon, MessageSquareTextIcon, SlidersHorizontalIcon, TypeIcon, UsersIcon } from "lucide-react";
import { Accent, Container, SectionHeader } from "./ui";
import { book, images } from "../data/content";
const icons = {
  users: UsersIcon,
  clipboard: ClipboardListIcon,
  type: TypeIcon,
  message: MessageSquareTextIcon,
  sliders: SlidersHorizontalIcon,
  calendar: CalendarDaysIcon
};
export function BookSection() {
  return <section className="bg-cream py-12 md:py-20" data-id="element-25" data-mp="37x5vd34qofp1">
      <Container data-id="element-26" data-mp="37xe9szgift2c">
        <SectionHeader eyebrow="What’s inside" title={<>
              10 group activities. <Accent data-id="element-28" data-mp="2xyoy5of7j4uj">The instructions and printables to lead them.</Accent>
            </>} data-id="element-27" data-mp="37us3121g1hl6" />

        <article className="grid grid-cols-1 items-start gap-8 rounded-2xl border border-line bg-white p-5 shadow-[0_12px_32px_rgba(22,78,85,0.07)] md:grid-cols-[minmax(0,300px)_1fr] md:gap-12 md:p-8" data-id="element-29" data-mp="1riczzncdxmyy">
          <img src={images.bookCover} alt="Cover of Volume 01 — Group Games & Social Fun" className="mx-auto h-auto w-full max-w-[260px] rounded-lg border border-line shadow-[0_16px_36px_rgba(22,78,85,0.14)]" data-id="element-30" data-mp="27moa9qf25ag" />
          <div data-id="element-31" data-mp="3of4d0grvll37">
            <p className="text-xs font-semibold uppercase tracking-[0.16em] text-muted" data-id="element-32" data-mp="3ohqkkgero0lf">{book.label}</p>
            <h3 className="mt-2 font-display text-[32px] font-bold uppercase leading-none text-petrol sm:text-[40px]" data-id="element-33" data-mp="3epkwvivjs5c1">
              {book.title}
            </h3>
            <p className="mt-3 text-base text-muted sm:text-lg" data-id="element-34" data-mp="3jhug6g25q75c">{book.description}</p>

            <ul className="mt-6 grid grid-cols-1 gap-3 sm:grid-cols-2" data-id="element-35" data-mp="35q660ibgxsr0">
              {book.components.map(c => {
              const Icon = icons[c.icon];
              return <li key={c.label} className="flex items-center gap-3" data-id="element-36" data-mp="2vrqggjs3arjm">
                    <span className="inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-sage text-petrol" data-id="element-37" data-mp="30pifdxr5jdxb">
                      <Icon className="h-[18px] w-[18px]" aria-hidden="true" data-id="element-38" data-mp="2hm87zsf77wmt" />
                    </span>
                    <span className="text-[15px] font-medium text-ink" data-id="element-39" data-mp="2cton0ae6lz7z">{c.label}</span>
                  </li>;
            })}
            </ul>

            <h4 className="mt-8 text-sm font-semibold uppercase tracking-[0.16em] text-ink" data-id="element-40" data-mp="22wiwp4de6c8t">Activities include</h4>
            <ul className="mt-2 divide-y divide-line border-y border-line" data-id="element-41" data-mp="30katvycg9dge">
              {book.sampleActivities.map(a => <li key={a.code} className="flex items-center gap-4 py-2.5" data-id="element-42" data-mp="2vlheu1hilee4">
                  <span className="w-12 shrink-0 font-display text-xl font-bold text-petrol" data-id="element-43" data-mp="2ql20p7pes2v3">{a.code}</span>
                  <span className="text-ink" data-id="element-44" data-mp="2llqma5cil9go">{a.name}</span>
                </li>)}
            </ul>
          </div>
        </article>

        <article className="mt-5 flex flex-col gap-4 rounded-2xl bg-sage p-6 sm:flex-row sm:items-center md:p-7" data-id="element-45" data-mp="1f4btbl9914zw">
          <span className="inline-flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-white text-petrol" data-id="element-46" data-mp="3lv8elsndrwld">
            <CalendarDaysIcon className="h-6 w-6" aria-hidden="true" data-id="element-47" data-mp="3qt9xodkt3vwu" />
          </span>
          <div data-id="element-48" data-mp="3vsmikss4asws">
            <h3 className="font-display text-[26px] font-bold uppercase leading-none text-petrol" data-id="element-49" data-mp="3vsuzcvrd2id9">
              The 12-month activity calendar
            </h3>
            <p className="mt-1.5 max-w-[700px] text-ink" data-id="element-50" data-mp="9djxycmuuds4">
              Helps you organize these activities across the year, alongside your community’s existing program.
            </p>
          </div>
        </article>
      </Container>
    </section>;
}